var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.427C12.4183 16.427 16 12.8453 16 8.427C16 4.00872 12.4183 0.427002 8 0.427002C3.58172 0.427002 0 4.00872 0 8.427C0.00478125 12.8433 3.58369 16.4222 8 16.427ZM7.33334 4.427C7.33334 4.05881 7.63181 3.76035 8 3.76035C8.36819 3.76035 8.66666 4.05881 8.66666 4.427V9.76035C8.66666 10.1285 8.36819 10.427 8 10.427C7.63181 10.427 7.33334 10.1285 7.33334 9.76035V4.427ZM8 12.427C8.36819 12.427 8.66666 12.7255 8.66666 13.0937C8.66666 13.4618 8.36819 13.7603 8 13.7603C7.63181 13.7603 7.33334 13.4618 7.33334 13.0937C7.33334 12.7255 7.63181 12.427 8 12.427Z",
    fill: "#C4314B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.eba4f0b62750a8442381d99cbebbf025.svg";
export { ForwardRef as ReactComponent };